<template>
    <div>
        <v-dialog
            v-model="display"
            scrollable
            :width="customers.length ? 750 : 500"
            persistent>
            <v-card>
                <v-card-title>
                    {{ $t('customer_search') }}
                </v-card-title>
                <v-card-text>
                    <v-text-field
                        v-model="search"
                        ref="searchField" 
                        @keypress.enter="searchCustomer"
                        :error="error.searchField.state"
                        :error-messages="error.searchField.message"
                        :loading="loading.search"
                        :label="$t('search')">
                    </v-text-field>
                    <v-data-table
                        v-if="customers.length"
                        height="300"
                        v-model="selected.customer"
                        :headers="headers.customer"
                        hide-default-footer
                        disable-pagination
                        show-select
                        single-select
                        dense
                        :items="customers"
                        >
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                        text
                        color="primary"
                        :disabled="!selected.customer.length"
                        @click="submit"
                        >
                        {{ $t('btn_select')}}
                    </v-btn>
                    <v-btn
                        text
                        color="error"
                        @click="close">
                        {{ $t("cancel_btn") }}
                    </v-btn>

                </v-card-actions>
            </v-card>
        </v-dialog>
        <RetryDialog
            ref="retryDialog"
            @submit="onRetryDialogSubmit"/>
    </div>
</template>

<script>
import RetryDialog from '@/components/common/RetryDialog';
import { mapState, mapActions } from 'vuex'
export default {
    name: "CustomerSearchDialog",
    components: {
        RetryDialog
    },
    data() {
        return {
            display: false,
            selected: {
                customer: []
            },
            loading: {
                data: true,
                search: false
            },
            error: {
                searchField: {
                    state: false,
                    message: null
                }
            },
            headers: {
                customer: [
                    { text: this.$t('code'), value: "code" },
                    { text: this.$t('name'), value: "name" },
                    { text: this.$t('phone'), value: "phone" }
                ]
            },
            search:  null
        }
    },
    computed: {
        ...mapState("sales/customer", ["customers"])
    },
    
    methods: {
        ...mapActions("sales/customer", ["fetchCustomers", "resetCustomers"]),
        open(params){
            this.search = params;
            this.loading.data = true;
            this.searchCustomer();
            this.display = true;
            this.resetCustomers();
        },
        async searchCustomer() {
            if(this.search) {
                this.clearError();
                this.loading.search = true;
                try {
                    await this.fetchCustomers({ search: this.search });
                    this.loading.search = false;
                    if(!this.customers.length) this.setError(this.$t('no_result'));
                    if(this.customers.length == 1) this.submit();
                } catch(error) {
                    this.loading.search = false;
                    let message = error.response ? error.response.data.message : error; 
                    this.setError(message);
                }
            } else {
                this.setError(this.$t('rules_required'))
            }
        },
        onRetryDialogSubmit(params){
            if(params.target == "openDataFetch") {
                if(params.retry) this.openDataFetch();
                else this.close()
            }
        },
        setError(message){
            this.error.searchField.state = true;
            this.error.searchField.message = message;
        },
        clearError(){
            this.error.searchField.state = false;
            this.error.searchField.message = null;
        },
       
        submit() {
            if(this.customers.length == 1) this.$emit('store', this.customers[0]);
            else this.$emit('store', this.selected.customer[0]);
            this.close();
        },
        close() {
            this.display = false;
            this.clearError();
            this.search = null;
            this.selected.customer = [];
        },

    }
}
</script>